import {
    ChevronDownIcon,
    ChevronUpIcon,
} from '../../Icon'
import Button from '../../Button'
import {ButtonProps} from '../../Button/types'
import React from 'react'
import {useDropdownMenuContext} from '../DropdownContext/dropdownContext'

interface DropdownButtonProps extends ButtonProps {
    caret?: boolean | undefined
    children?: React.ReactElement | JSX.Element | string | null
    overflowVisible?: boolean
}

const DropdownButtonView = (props: DropdownButtonProps): React.ReactElement => {
    const {
        caret,
        children,
        ...buttonProps
    } = props

    const {
        isOpen = false, onToggle,
    } = useDropdownMenuContext()

    const getIconRight = () => (buttonProps.iconRight ? buttonProps.iconRight : caret ? isOpen ? ChevronUpIcon : ChevronDownIcon : undefined)

    return (
        <Button
            aria-expanded={isOpen}
            aria-haspopup='true'
            data-name='dropdown-button'
            iconRight={getIconRight()}
            onPress={onToggle}
            {...buttonProps}
        >
            {children}
        </Button>
    )
}

DropdownButtonView.defaultProps = {
    caret: true,
    children: null,
    overflowVisible: false,
}


export default DropdownButtonView
